import { IApplicationState } from '../types/redux';

export const rootStateBranchSelector =
  <RootStateBranchName extends keyof IApplicationState>(rootStateBranchName: RootStateBranchName) =>
  (state: IApplicationState): IApplicationState[RootStateBranchName] =>
    state[rootStateBranchName];
